module.exports = __webpack_public_path__ + "static/asparagus-df6c4f7f3e60b0d5e6c0c290018c2c67.svg";